import { parse } from 'helpers';

export const checkRolePermission = (app_permissions) => {
  const appPermissions = parse(app_permissions);
  return appPermissions.app_general_log_into_app;
};
